import { useContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Signup from "../pages/auth/Signup";
import Dashboard from "../dashboard";
import VerifyAccount from "../pages/auth/VerifyAccount";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ProtectedRoute from "../components/ProtectedRoute";
import Header from "../components/Header";
import { LoggedInUserContext } from "../context/loggedInUserContext";
import { getItem } from "./localStorage";
import Account from "../pages/account";
import ActiveAccount from "../pages/account/activeAccount";
import SentEmail from "../pages/auth/ForgotPassword/sentEmail";
import Admin from "../pages/admin";
import PageNotFound from "../pages/errors/pageNotFound";
import AddCategory from "../pages/admin/categories/addCategory";
import MyAuctions from "../pages/account/tabComponents/myAuctions";
import SearchedAuctions from "../pages/auctions";
import EditAuctions from "../pages/account/editAuctions";
import { Roles } from "../types/role.enums";
import MyProfile from "../pages/account/tabComponents/myProfile";
const RoutesComp = () => {
  const { loggedInUserContext, setLoggedInUserContext } =
    useContext(LoggedInUserContext);
  useEffect(() => {
    const user = getItem("user");
    setLoggedInUserContext(user);
  }, [loggedInUserContext?.token]);
  return (
    <>
      <Header user={loggedInUserContext} />
      <Routes>
        <Route element={<Signup />} path="/signup" />
        <Route
          element={
            <ProtectedRoute
              allowedRoles={[Roles.USER]}
              userRole={loggedInUserContext?.role_name}
            >
              <Account />
            </ProtectedRoute>
          }
          path="/account"
        />

        <Route
          path="/admin"
          element={
            <ProtectedRoute
              allowedRoles={[Roles.SUPER_ADMIN]}
              userRole={loggedInUserContext?.role_name}
            >
              <Admin />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/add-category"
          element={
            <ProtectedRoute
              allowedRoles={[Roles.SUPER_ADMIN]}
              userRole={loggedInUserContext?.role_name}
            >
              <AddCategory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/update-category/:id"
          element={
            <ProtectedRoute
              allowedRoles={[Roles.SUPER_ADMIN]}
              userRole={loggedInUserContext?.role_name}
            >
              <AddCategory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/my-auctions"
          element={
            <ProtectedRoute
              allowedRoles={[Roles.USER, Roles.SUPER_ADMIN]}
              userRole={loggedInUserContext?.role_name}
            >
              <MyAuctions />
            </ProtectedRoute>
          }
        />

        <Route
          path="/auction/:id"
          element={
            <ProtectedRoute
              allowedRoles={[Roles.USER, Roles.SUPER_ADMIN]}
              userRole={loggedInUserContext?.role_name}
            >
              <EditAuctions />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/auction/:id"
          element={
            <ProtectedRoute
              allowedRoles={[Roles.SUPER_ADMIN]}
              userRole={loggedInUserContext?.role_name}
            >
              <EditAuctions />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/user-profile/:id"
          element={
            <ProtectedRoute
              allowedRoles={[Roles.SUPER_ADMIN]}
              userRole={loggedInUserContext?.role_name}
            >
              <MyProfile />
            </ProtectedRoute>
          }
        />

        <Route path="/auctions" element={<SearchedAuctions />} />
        <Route path="/reset-password/:id" element={<ForgotPassword />} />
        <Route path="/" element={<Dashboard />} />
        <Route path="/verify-account" element={<VerifyAccount />} />
        <Route
          path="/active-your-account/:id/:token"
          element={<ActiveAccount />}
        />
        <Route path="/forgot-password" element={<SentEmail />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};
export default RoutesComp;
